import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.DEALS_AND_PROMOS,
    name: "DealsAndPromos",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.DEALS_AND_PROMOS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.DEALS_AND_PROMOS.PERMISSIONS,
    },
    component: () => import("@/modules/Deals/views/DealsAndPromos.vue"),
  },
];

export default routes;
